module.exports = __webpack_public_path__ + "static/jcare-support-service-thumbnail-641262515a142db070845f513b3eb57d.png";